import React from "react";
import RightHandSide from "../../Common/Services/RightHandSide";
import AboutInnBanContent from "../../Common/InnerBanner/AboutInnBanContent";
import { AboutInnerBanner } from "../../Common/InnerBanner/AboutInnerBanner";
import HeadContent from "../BlogContent/HeadContent";
import HeadDesign from "../BlogContent/HeadDesign";
import Info from "../BlogContent/Info";
import List from "../BlogContent/List";
import InfoContent from "../BlogContent/InfoContent";
import ListContent from "../BlogContent/ListContent";
import RecentBlogsList from "../BlogContent/RecentBlogsList";
import { Helmet } from "react-helmet";

const Blog41 = () => {
  const { image, heading, pageName } = AboutInnBanContent.BlogDetails;
  const { bg, para, date, blogHeading } = HeadContent.blog_41;

  const { title, p } = InfoContent.Blog_41.one;
  const { title2, p2, p2a } = InfoContent.Blog_41.two;
  const { title3, p3 } = InfoContent.Blog_41.three;
  const { title4, p4, p4a } = InfoContent.Blog_41.four;
  const { title5, p5 } = InfoContent.Blog_41.five;
  const { Ctitle, Cp } = InfoContent.Blog_41.conclusion;
  //   const { title6, p6 , p6a } = InfoContent.Blog_41.six;
  //   const { title7, p7 } = InfoContent.Blog_41.seven;
  //   const { titlefaq, pfaq } = InfoContent.Blog_41.FAQ;
  //   const { title8, p8 } = InfoContent.Blog_41.eight;

  const { liss2 } = ListContent.Blog_41.L2;
  const { liss3 } = ListContent.Blog_41.L3;
  const { liss4 } = ListContent.Blog_41.L4;
  const { liss5 } = ListContent.Blog_41.L5;

  return (
    <>
      <Helmet>
        <title>
          Period Ke Kitne Din Baad Pregnancy Hoti Hai? | Gynecologist Hospital
          in Chembur
        </title>

        <meta
          name="description"
          content="Dजानिए period ke kitne din baad pregnant hoti hai? ओव्यूलेशन का सही समय और फर्टाइल डेज। सही डॉक्टर परामर्श के लिए Acme Fertilityl, top gynecologist hospital in chembur से संपर्क करें।"
        />

        <meta
          name="keywords"
          content="hidden costs of IVF, IVF cost in India, IVF cost breakdown, IVF treatment cost in India, IVF price in India 2026, IVF expenses in India, IVF medication cost, IVF injection cost, IVF diagnostic test cost, IVF lab charges, IVF additional costs, IVF package exclusions, embryo freezing cost, embryo storage cost, FET cost in India, frozen embryo transfer cost, ICSI cost, PGT-A cost, IVF treatment expenses, IVF cost Mumbai"
        />

        <link
          rel="canonical"
          href="https://www.acmefertility.com/41/Period-Ke-Kitne-Din-Baad-Pregnancy-Hoti-Hai"
        />

        {/* Article Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            "@id":
              "https://www.acmefertility.com/period-ke-kitne-din-baad-pregnancy-hoti-hai#blogposting",
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id":
                "https://www.acmefertility.com/period-ke-kitne-din-baad-pregnancy-hoti-hai",
            },
            headline:
              "Period Ke Kitne Din Baad Pregnancy Hoti Hai? (सटीक जानकारी)",
            description:
              "जानिए period ke kitne din baad pregnant hoti hai? ओव्यूलेशन का सही समय, फर्टाइल डेज की गणना और गर्भधारण के सबसे सटीक दिनों की पूरी जानकारी।",
            image: {
              "@type": "ImageObject",
              url: "https://www.acmefertility.com/wp-content/uploads/pregnancy-ovulation-guide.jpg",
            },
            inLanguage: "hi",
            author: {
              "@type": "MedicalClinic",
              name: "Acme Fertility",
              url: "https://www.acmefertility.com",
            },
            publisher: {
              "@type": "Organization",
              name: "Acme Fertility Center",
              url: "https://www.acmefertility.com",
              logo: {
                "@type": "ImageObject",
                url: "https://www.acmefertility.com/wp-content/uploads/logo.png",
              },
            },
          })}
        </script>

        {/* Author Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalClinic",
            "@id": "https://www.acmefertility.com/#author",
            name: "Acme Fertility",
            url: "https://www.acmefertility.com",
          })}
        </script>

        {/* FAQ Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "@id":
              "https://www.acmefertility.com/period-ke-kitne-din-baad-pregnancy-hoti-hai#faqpage",
            mainEntity: [
              {
                "@type": "Question",
                name: "पीरियड के कितने दिन बाद प्रेग्नेंसी होने के सबसे ज्यादा चांस होते हैं?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "आमतौर पर ओव्यूलेशन के आसपास प्रेग्नेंसी होने की संभावना सबसे ज्यादा होती है। 28 दिन के नियमित पीरियड साइकिल में ओव्यूलेशन लगभग 14वें दिन के आसपास हो सकता है, लेकिन हर महिला का साइकिल अलग हो सकता है।",
                },
              },
              {
                "@type": "Question",
                name: "फर्टाइल डेज क्या होते हैं?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "फर्टाइल डेज पीरियड साइकिल के वे दिन होते हैं जब गर्भधारण की संभावना अधिक होती है। इसमें ओव्यूलेशन से पहले के कुछ दिन और ओव्यूलेशन का दिन शामिल होता है।",
                },
              },
              {
                "@type": "Question",
                name: "ओव्यूलेशन कैसे पता कर सकते हैं?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "ओव्यूलेशन का अनुमान पीरियड साइकिल ट्रैक करके लगाया जा सकता है। वैजाइनल डिस्चार्ज में बदलाव, बेसल बॉडी टेम्परेचर में बदलाव और Ovulation Kit जैसे तरीकों से भी ओव्यूलेशन की पहचान करने में मदद मिल सकती है।",
                },
              },
              {
                "@type": "Question",
                name: "क्या पीरियड के तुरंत बाद प्रेग्नेंसी हो सकती है?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "हाँ, कुछ परिस्थितियों में पीरियड खत्म होने के तुरंत बाद भी प्रेग्नेंसी हो सकती है, विशेषकर यदि ओव्यूलेशन जल्दी हो और स्पर्म कई दिनों तक जीवित रहे। इसलिए केवल पीरियड खत्म होने के आधार पर गर्भधारण की संभावना को पूरी तरह नकारा नहीं जा सकता।",
                },
              },
              {
                "@type": "Question",
                name: "प्रेग्नेंसी प्लान करने के लिए डॉक्टर से कब सलाह लेनी चाहिए?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "यदि पीरियड साइकिल अनियमित है, लंबे समय से गर्भधारण नहीं हो रहा है, या ओव्यूलेशन को लेकर कोई समस्या है, तो स्त्री रोग विशेषज्ञ या फर्टिलिटी विशेषज्ञ से सलाह लेना उचित है। डॉक्टर आवश्यकता के अनुसार फॉलिक्युलर स्टडी जैसी जांच की सलाह दे सकते हैं।",
                },
              },
            ],
          })}
        </script>
        {/* Breadcrumb Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "@id":
              "https://www.acmefertility.com/period-ke-kitne-din-baad-pregnancy-hoti-hai#breadcrumb",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.acmefertility.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Fertility",
                item: "https://www.acmefertility.com/Fertility.php",
              },
              {
                "@type": "ListItem",
                position: 3,
                name: "Period Ke Kitne Din Baad Pregnancy Hoti Hai?",
                item: "https://www.acmefertility.com/period-ke-kitne-din-baad-pregnancy-hoti-hai",
              },
            ],
          })}
        </script>
      </Helmet>

      <AboutInnerBanner image={image} heading={heading} pageName={pageName} />

      <div className="blog-area pt-100 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <HeadDesign
                bg={bg}
                para={para}
                date={date}
                blogHeading={blogHeading}
              />

              <Info title={title} p={p} />
              <Info title={title2} p={p2} />
              <List liss={liss2} />
              <Info p={p2a} />
              <Info title={title3} p={p3} />
              <List liss={liss3} />
              <Info title={title4} p={p4} />
              <List liss={liss4} />
              <Info p={p4a} />
              <Info title={title5} p={p5} />
              <List liss={liss5} />
              <Info title={Ctitle} p={Cp} />
            </div>

            <div className="col-lg-4">
              <RecentBlogsList />
              <RightHandSide />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Blog41;
